module.exports = __webpack_public_path__ + "img/banner-large-cachesight.e06be210.png";